import { createNames } from "../../utils";
export const getAceDividerNames = (id) => {
    return createNames(id, 'ACE-DIVIDER');
};
export const aceDividerCssVariables = {
    COLOR: '--ace-divider-color',
};
//# sourceMappingURL=ace-divider.get-names.js.map
